import { Flex, Menu, MenuButton, Button, Avatar, Heading, MenuList, MenuDivider, MenuItem, Image, Badge, Spinner, Tooltip, Box, Text } from '@chakra-ui/react';
import { NavLink, useNavigate } from 'react-router-dom';
import { BellIcon, PhoneIcon } from '@chakra-ui/icons';
import * as routesNames from '../../constants/routes';
import ArrowDownIcon from '../../assets/images/arrow-down.svg';
import MyDiv from './navBar.style';
import { useAuth } from '../../hooks/useAuth';
import { useEffect, useState } from 'react';
import { baseUrl } from '../../hooks/useFetch';
import DummyPerson from '../../assets/images/DummyPerson.svg';
import { useFetch } from '../../hooks/useFetch';
import CustomToast from '../CustomToast';

const NavBar = () => {
  const navigate = useNavigate();
  const { logout, employeeName, employeeId, loginObj, hasPermission } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [remoteNotification, setRemoteNotification] = useState<any[]>([]);
  const [missingDocumentNotification, setMissingDocumentNotification] = useState<any[]>([]);
  const [meetingNotifications, setMeetingNotifications] = useState<any[]>([]);
  const [regularizationNotifications, setRegularizationNotifications] = useState<any[]>([]);
  const [leaveNotifications, setLeaveNotifications] = useState<any[]>([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [ivrRecord, setIvrRecord] = useState<any>(null);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const hasRegularizationPermission = hasPermission('Notification', 'Notification');
  const notifications = [...remoteNotification, ...missingDocumentNotification, ...meetingNotifications, ...regularizationNotifications, ...leaveNotifications];

  const handleNavigate = () => {
    navigate(routesNames.EMPLOYEEDETAIL, { state: { employeeId, myProfile: true } });
  };

  const fetchAvatar = async () => {
    try {
      const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employeeId}`, {
        headers: { Authorization: `Bearer ${loginObj?.token || ''}` }
      });
      const blob = await res.blob();
      setAvatarUrl(URL.createObjectURL(blob));
    } catch { }
  };

const fetchAllNotifications = async () => {
  setNotificationsLoading(true);
  try {
    const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const promises = [
      fetch(`${baseUrl}Remote/GetRemoteNotifications`, { headers: { Authorization: `Bearer ${loginObj?.token || ''}` } }),
      fetch(`${baseUrl}MissingDocument/missingDocument?showDetails=false`, { headers: { Authorization: `Bearer ${loginObj?.token || ''}` } }),
      fetch(`${baseUrl}Meetings/meetingNotification?timeZoneId=${timeZoneId}`, { headers: { Authorization: `Bearer ${loginObj?.token || ''}` } }),
    ];

    if (hasRegularizationPermission) {
      promises.push(
        fetch(`${baseUrl}Regularization/pending-approval-notification`, {
          headers: { Authorization: `Bearer ${loginObj?.token || ''}` }
        })
      );
    }
    if (hasRegularizationPermission) {
          promises.push(
            fetch(`${baseUrl}Regularization/pending-leave-notification`, {
              headers: { Authorization: `Bearer ${loginObj?.token || ''}` }
            })
          );
        }
    const responses = await Promise.all(promises);
    const data = await Promise.all(responses.map(r => r.json()));

    const [remoteData, missingDocData, meetingData, regularizationData, leaveData] = data;
    setRemoteNotification(remoteData.success ? remoteData.notifications : []);
    setMissingDocumentNotification(missingDocData.notifications || []);
    setMeetingNotifications(meetingData.success ? meetingData.notifications : []); 
    if (hasRegularizationPermission) {
      setRegularizationNotifications(regularizationData?.notifications || []);
    }
    if (hasRegularizationPermission) {
      setLeaveNotifications(leaveData?.notifications || []);
    }
  } catch (err) {
    console.error('Error fetching notifications', err);
  } finally {
    setNotificationsLoading(false);
  }
};


  const handleLogout = async () => {
    await fetchApi("user/logout", "POST");
    logout();
  };

  useEffect(() => {
    fetchAvatar();
    fetchAllNotifications();
    const interval = setInterval(fetchAllNotifications, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateAvatar = (e: any) => setAvatarUrl(e.detail);
    window.addEventListener('avatarUpdated', updateAvatar);
    return () => window.removeEventListener('avatarUpdated', updateAvatar);
  }, []);

  const navigateRoutes = (n: any) => {
    if (n?.type === 'Employee') {
      navigate(routesNames.REMOTEREQUEST, { state: { defaultTab: 5 } });
    } else if (n?.type === 'Approver') {
      navigate(routesNames.REMOTEWORKTIMEAPPROVAL);
    } else if (n?.type === 'HrDocNotification') {
      navigate(routesNames.MISSINGDOCUMENTS);
    } else if (n?.type === 'EmployeeDocNotification') {
      navigate(routesNames.EMPLOYEEDETAIL, { state: { employeeId, myProfile: true } });
    } else if (n?.type === 'RegularizationNotification') {
      navigate(routesNames.REGULARISATION, );
    }
    else if (n?.type === 'LeaveNotification') {
      navigate(routesNames.LEAVESREQUEST, );
    }else if (n?.meetingId) {
      navigate(routesNames.MEETINGSMANAGEMENT);
    }
  };

  const getNotificationIcon = (n: any) => {
    if (n?.status === 'Running') return '🟢';
    if (n?.status === 'Today') return '🔵';
    if (n?.meetingId) return '📅';
    if (n?.type === 'HrDocNotification' || n?.type === 'EmployeeDocNotification') return '📄';
    return '🔔';
  };

  const loadRecords = async () => {
    const response = await fetchApi<any[]>("IVR/IVR_Mast", "GET");
    if (response && response.length > 0) {
      setIvrRecord(response[0]);
    }
  };

  useEffect(() => {
    loadRecords();
  }, []);


  return (
    <MyDiv>
      <Flex align="center" justify="space-between">

        <Menu>
          <Tooltip label="Notifications" placement="bottom">
            <MenuButton as={Button} variant="ghost" p={2} position="relative" mr={3}
              _hover={{ bg: 'gray.100' }} className="blink_bell">
              <BellIcon boxSize={5} color="gray.700" />
              {notifications.length > 0 && (
                <Badge colorScheme="red" borderRadius="full" position="absolute"
                  top="2px" right="2px" fontSize="0.7em" className="blink_badge">
                  {notifications.length}
                </Badge>
              )}
            </MenuButton>
          </Tooltip>

          <MenuList w="540px" maxH="300px" overflowY="auto" boxShadow="lg"
            borderRadius="md" bg="white" px={2}
            css={{
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-thumb': { background: '#CBD5E0', borderRadius: '4px' },
              '&::-webkit-scrollbar-thumb:hover': { background: '#A0AEC0' },
            }}>
            {notificationsLoading ? (
              <Flex justify="center" align="center" py={4}>
                <Spinner size="sm" />
              </Flex>
            ) : notifications.length === 0 ? (
              <Box p={4}>
                <Text fontSize="sm" color="gray.500" textAlign="center">
                  No new notifications
                </Text>
              </Box>
            ) : (
              notifications.map((n, idx) => (
                <MenuItem key={idx} onClick={() => navigateRoutes(n)}
                  borderRadius="md" _hover={{ bg: 'gray.50' }} whiteSpace="normal">
                  <Box>
                    <Text className="font-poppins text_regular text_sm">
                      {getNotificationIcon(n)} {n?.message}
                    </Text>
                  </Box>
                </MenuItem>
              ))
            )}
          </MenuList>
        </Menu>

        {/* 📞 Support Call */}
        <Box mr={3}>
          <Menu placement="bottom-start">
            <MenuButton as={Button} leftIcon={<PhoneIcon color="green.500" />}
              bg="#FFFFFF" borderRadius="lg" px={4} py={2}
              className='font-poppins text_md text_medium'>
              Support Call
            </MenuButton>
            <MenuList minW="220px">
              <MenuItem>
                <Box>
                  <Text fontWeight="semibold" color="green.600">HR Department</Text>
                  <Text fontSize="sm">{ivrRecord?.hr_No}</Text>
                </Box>
              </MenuItem>
              <MenuItem>
                <Box>
                  <Text fontWeight="semibold" color="green.600">Account Team</Text>
                  <Text fontSize="sm">{ivrRecord?.accountant_No}</Text>
                </Box>
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>

        {/* 👤 Profile Dropdown */}
        <Menu>
          <Flex className="profile_menu">
            <MenuButton as={Button}
              leftIcon={<Avatar size='2xs' src={avatarUrl || DummyPerson} />}
              rightIcon={<Image src={ArrowDownIcon} />}>
              <Heading as="h1" className="font-poppins font_dark text_semibold text_md">
                {employeeName}
              </Heading>
            </MenuButton>
          </Flex>
          <MenuList className="dropdown_list">
            <MenuItem onClick={handleNavigate} className="font-poppins font_dark text_medium text_md">
              My Profile
            </MenuItem>
            <MenuDivider mt={0} mb={0} className="divider" />
            <MenuItem as={NavLink} to={routesNames.EMPLOYEEGALLERY}
              className="font-poppins font_dark text_medium text_md">
              Gallery
            </MenuItem>
            <MenuDivider mt={0} mb={0} className="divider" />
            {hasPermission('Master', 'Masters') && (
              <MenuItem as={NavLink} to={routesNames.Master}
                className="font-poppins font_dark text_medium text_md">
                Master
              </MenuItem>
            )}
            <MenuDivider mt={0} mb={0} className="divider" />
            <MenuItem onClick={handleLogout}
              className="font_poppins font_dark text_md text_medium logout_user">
              Logout
            </MenuItem>
          </MenuList>
        </Menu>

      </Flex>
    </MyDiv>
  );
};

export default NavBar;
